import { defineMessage } from '../../services/localization';

export const messages = {
    weCouldntLoad: defineMessage('we_couldnt_load_the_content_1'),
    pleaseReload: defineMessage('please_reload_this_page__please_contact_support'),
    contactSupport: defineMessage('contact_support'),
    reloadPage: defineMessage('reload_page'),
};
